<template>
    <div>
        <a href="#" @click.prevent="show = true" class="text-orange hover:text-orange-400">
            What is 5/24?
        </a>
        <div
            class="modal"
            v-if="show"
            aria-labelledby="fivetwentyfour-modal"
            role="dialog"
            aria-modal="true"
        >
            <div class="modal-overlay" aria-hidden="true"></div>
            <div class="inner rounded-lg bg-white shadow border border-gray-200 overflow-hidden w-full max-w-3xl p-4" style="-webkit-transform:translate3d(0,0,0);">
				<div class="absolute top-0 right-0 pt-4 pr-6 block">
			          <button type="button" class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-orange-400 focus:ring-offset-2" @click.prevent="closeModal()">
			            <span class="sr-only">Close</span>
							<i class="fal fa-times fa-2x"></i>
			          </button>
			      </div>
                <div class="modal-body items-start prose">
					<img
                        src="/images/fivetwentyfour.png"
                        class="mx-auto w-1/3 mb-1"
                        alt="What is 5/24?"
                    />
                    <h3 class="text-xl md:text-2xl text-gray-800 font-bold mt-2 mb-5 text-center">What is the 5/24 Rule?</h3>
					<p class="mb-5 font-normal">To be approved for a new credit card from Chase, you can’t have opened five or more personal credit cards across all banks within the past 24 months. This means that you must be under five personal credit cards to be approved.</p>

					<p class="text-center font-normal">
						<a href="https://10xtravel.com/chase-5-24-rule/" class="btn btn-gray no-underline" role="button" target="_blank">
							Learn More About 5/24
						</a>
					</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useWalletStore } from '@/store/wallet'

const show = ref(false)
const walletStore = useWalletStore()
const { cards } = storeToRefs(walletStore)

const closeModal = () => {
    show.value = false
}

watch(show, async (newValue) => {
    if (newValue) {
        await walletStore.getCards()
    }
})
</script>
